/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-logement-false': {
    width: 67,
    height: 74,
    viewBox: '0 0 67 74',
    data: '<path pid="0" class="st0" d="M64.8 19.1L39 .7c-.7-.5-1.4-.7-2.2-.7s-1.5.2-2.1.7L8.9 19.1c-1.3.9-1.9 2.6-1.4 4.1s1.9 2.6 3.5 2.6h3.7v2.1c1.2-.9 2.4-1.7 3.7-2.4v-3.3H11L36.8 3.7l25.8 18.4h-7.4v33.2h-7c-.7 1.3-1.5 2.5-2.4 3.7h9.4c2 0 3.7-1.6 3.7-3.7V25.8h3.7c1.6 0 3-1 3.5-2.6s0-3.2-1.3-4.1"/><path pid="1" class="st0" d="M39.1 55.5c-2.9 2.9-6.7 4.3-10.4 4.3-3.8 0-7.5-1.4-10.4-4.3-5.8-5.8-5.7-15.1 0-20.8 2.9-2.9 6.6-4.3 10.4-4.3 3.8 0 7.5 1.4 10.4 4.3 5.7 5.7 5.7 15 0 20.8M41.7 32c-3.5-3.5-8.1-5.4-13-5.4s-9.5 1.9-13 5.4C9 38.7 8.6 49.4 14.5 56.6L0 71.1l2.6 2.6L17 59.3c3.3 2.7 7.3 4.2 11.6 4.2 4.9 0 9.5-1.9 13-5.4 3.5-3.5 5.4-8.1 5.4-13 .1-5-1.9-9.6-5.3-13.1"/>'
  }
})
